import { MenuItem, Select, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { ThemePalette } from 'mui.theme';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface SortByProps {
  selected: string;
  setSelected: React.Dispatch<React.SetStateAction<string>>;
  minWidth?: string;
  disabled?: boolean;
  options: string[];
  getOptionLabel?: (option: string) => string;
}

const SortBy = ({
  selected,
  setSelected,
  minWidth,
  disabled,
  options,
  getOptionLabel = (option: string) => option,
}: SortByProps) => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        minWidth: '200px',
        justifyContent: 'flex-end',
      }}
    >
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: '600',
          color: palette.textSecondary,
          paddingLeft: '10px',
          paddingRight: '15px',
          paddingTop: '5px',
        }}
      >
        {t('sort_by_10')}
      </Typography>

      <Select
        size="small"
        value={selected}
        onChange={(event) => {
          setSelected(event.target.value);
        }}
        sx={{
          textTransform: 'capitalize',
          minWidth,
          height: '30px',
          fontSize: '11px',
          backgroundColor: enableDarkTheme
            ? ThemePalette.dark.cartesianGrid
            : palette.boxBackground,
          color: palette.textPrimary,
          '& .MuiSelect-icon': {
            color: palette.textPrimary,
          },
          '& fieldset': {
            borderColor: palette.textPrimary,
          },
          ...(enableDarkTheme && {
            '&.MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: palette.cardBorderColor, // <------------------ outline-color by default
              },
            },
          }),
        }}
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: enableDarkTheme
                ? palette.menuOptions
                : palette.boxBackground,
              color: enableDarkTheme
                ? ThemePalette.typography.grey
                : ThemePalette.typography.black,
              fontSize: '12px',
            },
          },
        }}
        disabled={disabled}
      >
        {options.map((option: any) => (
          <MenuItem
            key={option}
            value={option}
            sx={{
              fontSize: '12px',
              textTransform: 'capitalize',
            }}
          >
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default SortBy;
